import React, { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as Icons from 'lucide-react';

const MarathiDashboardLayout = ({ children, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const mainMenuItems = [
    { icon: 'LayoutDashboard', label: 'Dashboard', path: '/marathi-dashboard' },
    { icon: 'FileText', label: 'Articles', path: '/marathi-dashboard/articles' },
    { icon: 'BookOpen', label: 'Blogs', path: '/marathi-dashboard/blogs' },
    { icon: 'Info', label: 'Infomatics', path: '/marathi-dashboard/infomatics' },
    { icon: 'Quote', label: 'Quotes', path: '/marathi-dashboard/quotes' },
    { icon: 'MessageSquare', label: 'Speeches', path: '/marathi-dashboard/speeches' },
    { icon: 'Camera', label: 'Photo Gallery', path: '/marathi-dashboard/photos' },
    { icon: 'Video', label: 'Video Gallery', path: '/marathi-dashboard/videos' },
    { icon: 'Users', label: 'Subscribers', path: '/marathi-dashboard/subscribers' },
    { 
      icon: 'MessageCircle', 
      label: 'View Comments', 
      path: '/marathi-dashboard/comments' 
    },
  ];

  const bottomMenuItems = [
    { 
      icon: 'RefreshCw', 
      label: 'Switch Portal', 
      path: '/dashboard',
      onClick: () => navigate('/dashboard')
    },
    { icon: 'LogOut', label: 'Logout', path: '#', onClick: onLogout },
  ];

  const handleNavigation = useCallback((item) => {
    try {
      if (item.onClick) {
        item.onClick();
      } else if (item.path) {
        navigate(item.path);
      }
    } catch (error) {
      console.error('Navigation error:', error);
    }
  }, [navigate]);

  const isActivePath = useCallback((path) => {
    return location.pathname === path;
  }, [location]);

  const renderIcon = (iconName) => {
    const Icon = Icons[iconName];
    return Icon ? <Icon className="w-5 h-5" /> : null;
  };

  return (
    <div className="flex h-screen bg-red-50">
      {/* Sidebar */}
      <div className="w-64 bg-red-800 text-white shadow-lg flex flex-col">
        {/* Logo Area */}
        <div className="flex items-center gap-2 px-6 py-4 border-b border-red-700">
          {renderIcon('LayoutDashboard')}
          <span className="text-lg font-semibold">RajendraShende.blog</span>
        </div>

        {/* Main Menu */}
        <div className="px-4 py-2 flex-grow overflow-y-auto">
          <nav className="space-y-1">
            {mainMenuItems.map((item) => (
              <button
                key={item.label}
                onClick={() => handleNavigation(item)}
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm rounded-lg transition-colors duration-150 ${
                  isActivePath(item.path)
                    ? 'bg-red-700'
                    : 'hover:bg-red-700'
                }`}
              >
                {renderIcon(item.icon)}
                <span>{item.label}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Divider */}
        <div className="px-6 py-4">
          <hr className="border-red-700" />
        </div>

        {/* Bottom Menu */}
        <div className="px-4 pb-4">
          <nav className="space-y-1">
            {bottomMenuItems.map((item) => (
              <button
                key={item.label}
                onClick={() => handleNavigation(item)}
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm rounded-lg transition-colors duration-150 ${
                  isActivePath(item.path)
                    ? 'bg-red-700'
                    : 'hover:bg-red-700'
                }`}
              >
                {renderIcon(item.icon)}
                <span>{item.label}</span>
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 overflow-auto">
        <div className="p-8">
          {children}
        </div>
      </div>
    </div>
  );
};

export default MarathiDashboardLayout;